import { render, staticRenderFns } from "./AuctionViewProperties.vue?vue&type=template&id=d65d83a6"
import script from "./AuctionViewProperties.vue?vue&type=script&lang=js"
export * from "./AuctionViewProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports